import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useClaimDataEntriesQuery, useClaimQuery, useInvoiceQuery } from '../../../api/gql';
import { UpdateAmountDueModule } from '../../../modules/dialogs/update-amount';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';

export const ClaimUpdateAmountPage = () => {
  const { invoiceId } = useParams();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  if (!invoiceId) {
    throw new Error('Unexpected - route variable :invoiceId is missing.');
  }

  return (
    <UpdateAmountDueModule
      transNs={'page-claim-detail'}
      invoiceId={invoiceId}
      keyPrefix={'updateAmountBox.dialog'}
      onSuccess={({ setDueAmount }) => {
        queryClient.setQueryData(useClaimQuery.getKey({ id: setDueAmount.id }), {
          invoice: { ...setDueAmount },
        });
        queryClient.setQueryData(useInvoiceQuery.getKey({ id: setDueAmount.id }), {
          invoice: { ...setDueAmount },
        });
        queryClient.invalidateQueries({
          queryKey: useClaimDataEntriesQuery.getKey({ id: invoiceId }),
        });
        safeNavigate(`/claim/${setDueAmount.id}`);
      }}
    />
  );
};
